import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import Login from './components/Login';
import Settings from './components/Settings';
import Export from './components/Export';
import Header from './components/Header';
import LoadingComponent from './components/LoadingComponent';
import AuthenticatedComponent from './components/AuthenticatedComponent';
import './styles/index.css';
import './styles/sliders.css';
import './styles/bubbles.css';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

// For Material-UI theming docs see http://www.material-ui.com/#/customization/themes
let primary1Color = "#21323e";

const telescopeTheme = getMuiTheme({
  palette: {
    primary1Color: primary1Color,
    primary2Color: primary1Color,
    primary3Color: primary1Color,
    accent1Color: primary1Color,
    accent2Color: primary1Color,
    accent3Color: primary1Color ,
  },
});

ReactDOM.render(
    <Provider store={store}>
      <MuiThemeProvider muiTheme={getMuiTheme(telescopeTheme)}>
        <BrowserRouter>
          <LoadingComponent>
            <div>
              <Switch>
                <Route path="/login" component={Login} exact={true} />
                <Redirect from="/logout" to="/login" />
                <AuthenticatedComponent>
                  <Header />
                  <Route path="/" component={App} exact={true} />
                  <Route path="/p/:view" component={App} exact={true} />
                  <Route path="/portfolio" component={App} exact={true} />
                  <Route path="/recommendations" component={App} exact={true} />
                  <Route path="/dashboard" component={App} exact={true} />
                  <Route path="/insights/:report" component={App} exact={true} />
                  <Route path="/settings" component={Settings} exact={true} />
                  <Route path="/export" component={Export} exact={true} />
                </AuthenticatedComponent>
              </Switch>
            </div>
          </LoadingComponent>
        </BrowserRouter>
      </MuiThemeProvider>
    </Provider>,
    document.getElementById('root')
);
//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js